<template>
    <div class="clearfix rounded pb-5 mx-auto">
        <h4 class="atlhr-dashboard-title mt-10 px-0 mb-0">GF Contribution Process Policy<span>
            <a v-bind:href="$api_url+'/company/dashboard'">Dashboard</a> / Settings / GF Process Settings / GF Contribution Process Policy</span>
        </h4>

        <div class="ibox mt-4">
            <div class="ibox-content">

                <form enctype="multipart/form-data" @submit.stop.prevent="formSubmit">
                    <div v-if="$acl['company/savegfsettings'] > 0" id="gf_contribution_policy_settings">
                        <div class="clearfix row no-margin">
                            <div class="col-md-12 fixed-section-one mb-4">
                                <div class="clearfix approval-container row">
                                    <div class="col-4 approve-level-label">
                                        <div class="approve-level-title">
                                            GF Contribution Process Policy Selection
                                        </div>
                                        <div class="approve-level-description">
                                            GF Contribution Process Policy Selection allows you to choose the policy used for processing Gratuity Fund contributions. The selected policy determines how contributions are calculated and applied, ensuring that all gratuity calculations follow your organization's defined rules and requirements.
                                        </div>
                                    </div>
                                    <div class="col-8 approve-level-content">
                                        <p class="service_length_title salary-heads">GF Contribution Process Policy <b-icon icon="info-circle" title="Service length will show on all reports and slips in selected format" v-b-tooltip></b-icon></p>
                                        <div>
                                            <b-form-group id="contribution_policy-group" label="Select a Contribution Policy" label-for="contribution_policy" class="required-field">
                                                <b-form-select name="contribution_policy" class="form-control" v-model="fdata.gf_contribution_policy" :options="contribution_policy_list" v-validate="{ required: true }" :state="validateState('contribution_policy')" aria-describedby="contribution_policy-feedback" data-vv-as="Contribution Policy">
                                                </b-form-select>
                                                <b-form-invalid-feedback id="contribution_policy-feedback">{{ veeErrors.first('contribution_policy') }}</b-form-invalid-feedback>
                                            </b-form-group>
                                        </div>
                                        <div class="row mx-1 py-2 w-100 align-items-center no-margin">
                                            <div class="col-sm-12 text-right">
                                                <button type="submit" class="btn btn-primary btn-md">SAVE</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </form>

            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: ['companyid', 'pageurl'],

    data() {
        return {
            company_id: this.companyid,

            contribution_policy_list: [
                { value: 1, text: 'Direct Balance Contribution' },
                { value: 2, text: 'Dynamic Proportion Based Contribution' },
                { value: 3, text: 'Actuarial Amount Based Contribution' },
                { value: 4, text: 'Actuarial Rate Based Contribution' },
            ],

            fdata: {
                gf_contribution_policy: 1,
                // NOT edited on this tab. Kept in sync with the last-fetched values and
                // re-sent unchanged on save so this form doesn't wipe out whatever the
                // "GF General Setting" tab has set. /gf/savegfsettings currently expects
                // all GF fields together in one payload — see formSubmit() below.
                enable_gratuity_fund: true,
                gf_migration_support: true,
                gf_financial_year_end_month: 6,
                gf_migration_month: 1,
                gf_migration_year: new Date().getFullYear(),
                company_gf_service_month: 'no',
                // gratuity_fund_investment_feature: false,
            },
        };
    },

    methods: {
        validateState(ref) {
            if (this.veeFields[ref] && (this.veeFields[ref].dirty || this.veeFields[ref].validated)) {
                return !this.veeErrors.has(ref);
            }
            return null;
        },

        getCompanyGFSettings() {
            let formData = new FormData();
            axios.post(this.$api_url + '/gf/companygfsettings', formData)
                .then((response) => {
                    if (response.data.data) {
                        const s = response.data.data;

                        this.fdata.gf_contribution_policy =
                            (s.gf_contribution_policy.opt_value == 0 || s.gf_contribution_policy.opt_value == 'null')
                                ? 1
                                : s.gf_contribution_policy.opt_value;

                        this.fdata.enable_gratuity_fund = s.gf_enabled.opt_value == 'true';
                        this.fdata.gf_migration_support = s.gf_migration_support.opt_value == 'true';
                        this.fdata.gf_financial_year_end_month =
                            (s.gf_year_end.opt_value == 0 || s.gf_year_end.opt_value == 'null')
                                ? 6
                                : s.gf_year_end.opt_value;
                        this.fdata.company_gf_service_month =
                            parseInt(s.gf_service_month_format.opt_value) == 1 ? 'yes' : 'no';
                        this.fdata.gf_migration_month = parseInt(s.gf_migration_month.opt_value);
                        this.fdata.gf_migration_year = parseInt(s.gf_migration_year.opt_value);
                        // this.fdata.gratuity_fund_investment_feature = parseInt(s.gratuity_fund_investment_feature.opt_value) === 1;
                    }
                });
        },

        formSubmit(e) {
            e.preventDefault();

            let currentObj = this;
            let formData = new FormData();
            const config = { headers: { 'content-type': 'multipart/form-data' } };

            let gf_service_month_format = (this.fdata.company_gf_service_month == 'no') ? 0 : 1;

            // formData.append('company_id', this.company_id);
            formData.append('gf_contribution_policy', this.fdata.gf_contribution_policy);
            // Re-send the last-fetched General Settings values untouched
            // on fdata above.
            formData.append('company_gf_status', this.fdata.enable_gratuity_fund);
            formData.append('gf_migration_support', this.fdata.gf_migration_support);
            formData.append('gf_financial_year_end_month', this.fdata.gf_financial_year_end_month);
            formData.append('gf_service_month_format', gf_service_month_format);
            formData.append('gf_migration_month', this.fdata.gf_migration_month);
            formData.append('gf_migration_year', this.fdata.gf_migration_year);
            // formData.append('gratuity_fund_investment_feature', this.fdata.gratuity_fund_investment_feature ? 1 : 0);

            axios.post(this.$api_url + '/gf/savegfsettings', formData, config)
                .then((response) => {
                    if (response.data.data) {
                        this.getCompanyGFSettings();
                        this.$bvToast.toast('GF Contribution Process Policy saved', { title: 'Success', variant: 'success', solid: true });
                    } else {
                        this.$bvToast.toast('An error occurred, please try again later', { title: 'Error!', variant: 'danger', solid: true });
                    }
                })
                .catch((error) => {
                    currentObj.$bvToast.toast(error, { title: 'Error!', variant: 'danger', solid: true });
                });
        },

        getcompany() {
            let formData = new FormData();
            axios.post(this.$api_url + '/company/getcompany', formData)
                .then((response) => {
                    this.company_id = response.data;
                    if (this.company_id > 0) {
                        this.getCompanyGFSettings();
                    }
                });
        },
    },

    created() {
        this.getcompany();
    },
};
</script>

<style scoped>
.service_length_title[data-v-83ba1f78] {
    margin-top: 33px;
    margin-bottom: 10px;
}
</style>